const PopUpCustomerCalendar = ({ onClick }) => {
  return (
    <div className={"project-step-payment__popup pop-up-base-style active"}>
      <div className={"pop-up-simple center"}>
        <img
          className={"pop-up-simple-cross"}
          onClick={onClick}
          src={"/images/pictos/cross-close.svg"}
          alt={"cross"}
        />
        <img
          className={"pop-up-simple-img"}
          src="/images/medias/popup.svg"
          alt="popup forms"
        />
        <h4 style={{ marginBottom: "10px" }}>
          Prise de rendez-vous sur le calendrier
        </h4>
        <span
          className={"text-primary color-primary"}
        >
          Le calendrier vous permet de visualiser les créneaux disponibles sur
          l'instant. Vous pourrez réserver une date et un créneau de visite pour
          le passage du diagnostiqueur après avoir validé l'étape de paiement.
          Vous pourrez modifier votre date de visite jusqu'à deux jours avant la
          date initiale de la visite.
        </span>

        <div className={"pop-up-simple-btns"}>
          <button className={"btn-default btn-default-primary"} onClick={onClick}>
            Visualiser calendrier
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopUpCustomerCalendar;
